import React from 'react';

export const IconNoFilesFound: React.FC = () => {
    return (
        <svg width='248' height='212' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <defs>
                <filter
                    id='b'
                    x='109.14'
                    y='-.58'
                    width='128.97'
                    height='141.19'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'>
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='16.6' />
                    <feGaussianBlur stdDeviation='11.07' />
                    <feComposite in2='hardAlpha' operator='out' k2='-1' k3='1' />
                    <feColorMatrix values='0 0 0 0 0.39608 0 0 0 0 0.47843 0 0 0 0 0.57647 0 0 0 0.27 0' />
                    <feBlend in2='BackgroundImageFix' result='effect_dropShadow_1' />
                    <feBlend in='SourceGraphic' in2='effect_dropShadow_1' result='shape' />
                </filter>
                <filter
                    id='c'
                    x='-.21'
                    y='17.55'
                    width='126.54'
                    height='119.89'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'>
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='16.6' />
                    <feGaussianBlur stdDeviation='11.07' />
                    <feComposite in2='hardAlpha' operator='out' k2='-1' k3='1' />
                    <feColorMatrix values='0 0 0 0 0.39608 0 0 0 0 0.47843 0 0 0 0 0.57647 0 0 0 0.27 0' />
                    <feBlend in2='BackgroundImageFix' result='effect_dropShadow_1' />
                    <feBlend in='SourceGraphic' in2='effect_dropShadow_1' result='shape' />
                </filter>
                <filter
                    id='d'
                    x='52.01'
                    y='36.27'
                    width='112.9'
                    height='123.91'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'>
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='16.6' />
                    <feGaussianBlur stdDeviation='11.07' />
                    <feComposite in2='hardAlpha' operator='out' k2='-1' k3='1' />
                    <feColorMatrix values='0 0 0 0 0.39608 0 0 0 0 0.47843 0 0 0 0 0.57647 0 0 0 0.27 0' />
                    <feBlend in2='BackgroundImageFix' result='effect_dropShadow_1' />
                    <feBlend in='SourceGraphic' in2='effect_dropShadow_1' result='shape' />
                </filter>
                <filter
                    id='e'
                    x='125.93'
                    y='77.43'
                    width='121.92'
                    height='122.14'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'>
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='16.6' />
                    <feGaussianBlur stdDeviation='11.07' />
                    <feComposite in2='hardAlpha' operator='out' k2='-1' k3='1' />
                    <feColorMatrix values='0 0 0 0 0.39608 0 0 0 0 0.47843 0 0 0 0 0.57647 0 0 0 0.27 0' />
                    <feBlend in2='BackgroundImageFix' result='effect_dropShadow_1' />
                    <feBlend in='SourceGraphic' in2='effect_dropShadow_1' result='shape' />
                </filter>
                <filter
                    id='f'
                    x='34.42'
                    y='75.09'
                    width='186.69'
                    height='135.93'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'>
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='16.6' />
                    <feGaussianBlur stdDeviation='11.07' />
                    <feComposite in2='hardAlpha' operator='out' k2='-1' k3='1' />
                    <feColorMatrix values='0 0 0 0 0.39608 0 0 0 0 0.47843 0 0 0 0 0.57647 0 0 0 0.27 0' />
                    <feBlend in2='BackgroundImageFix' result='effect_dropShadow_1' />
                    <feBlend in='SourceGraphic' in2='effect_dropShadow_1' result='shape' />
                </filter>
                <linearGradient id='a' x1='125.15' y1='84.88' x2='125.15' y2='109.83' gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#B0BACC' />
                    <stop offset='1' stopColor='#969EAE' />
                </linearGradient>
                <linearGradient id='g' x1='127.72' y1='90.08' x2='127.72' y2='161.96' gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#FDFEFF' />
                    <stop offset='1' stopColor='#ECF0F5' />
                </linearGradient>
            </defs>
            <path
                d='M126.9 169.92a70.65 70.65 0 0 0 70.6-70.6 70.65 70.65 0 0 0-70.6-70.6 70.47 70.47 0 0 0-70.6 70.6 70.56 70.56 0 0 0 70.6 70.6Z'
                fill='#EAEEF9'
            />
            <path
                d='M82.48 80.02h85.34c3.2 0 6.07 2.72 6.07 6.07v53.86c0 3.2-2.71 6.07-6.07 6.07H82.48a6.16 6.16 0 0 1-6.07-6.07V86.09a6.17 6.17 0 0 1 6.07-6.07Z'
                fill='url(#a)'
            />
            <path
                d='M209.03 81.67a5.35 5.35 0 0 0 .29-7.59 5.35 5.35 0 0 0-7.59-.29 5.35 5.35 0 0 0-.29 7.59 5.47 5.47 0 0 0 7.59.29ZM209.32 57.6c.87-.87 1.02-2.33.14-3.21-.87-.87-2.33-1.02-3.21-.14-.87.87-1.02 2.33-.14 3.21a2.17 2.17 0 0 0 3.21.14ZM151.99 24.49c.59-.58.73-1.61.15-2.19-.58-.58-1.61-.73-2.19-.14-.58.58-.73 1.6-.14 2.18.58.59 1.6.73 2.18.15Z'
                fill='#EAEEF9'
            />
            <g filter='url(#b)'>
                <path
                    d='m204.9 51.57-21.26 37.88c-.8 1.28-2.39 1.76-3.51.96l-36.44-21.26c-1.28-.8-1.76-2.39-.96-3.51l27.97-48.27c.8-1.28 2.4-1.76 3.51-.96l26.37 15.35 4.32 19.81Z'
                    fill='#F2F6FA'
                />
            </g>
            <path d='m200.58 31.76-6.07 10.22a3.1 3.1 0 0 0 1.12 4.16l9.11 5.27-4.16-19.65Z' fill='#D5DAE6' />
            <path
                d='M175.49 41.66c.64-.16 1.28-.16 1.76-.16h1.92c.64.16 1.44.32 2.08.48.79.32 1.43.64 2.07.96a7.08 7.08 0 0 1 2.4 1.92 6.02 6.02 0 0 1 1.44 2.4c.32.8.32 1.76.32 2.55a7.88 7.88 0 0 1-.96 2.72c-.48.8-.96 1.44-1.6 2.08-.64.48-1.12.8-1.92 1.12-.64.32-1.28.48-1.91.48l-1.76.16c-.48 0-.96.16-1.6.32-.48.16-.8.32-1.12.64l-1.76 2.23-2.87-1.59 1.27-2.88c.16-.48.64-.96.96-1.28.48-.32.96-.48 1.44-.64.64-.16 1.12-.16 1.76-.32.64 0 1.28-.16 1.92-.32a7.8 7.8 0 0 0 1.76-.64c.63-.32.95-.8 1.27-1.44.16-.32.32-.8.48-1.27 0-.48 0-.8-.16-1.12-.16-.48-.32-.8-.64-1.12-.32-.32-.64-.64-1.11-.96a5.91 5.91 0 0 0-1.76-.8c-.48-.16-.96-.16-1.44-.16h-1.12c-.16 0-.48 0-.64-.16-.32-.16-.64-.64-.64-.96l.16-2.24Zm-8.15 21.1c.16-.32.48-.64.8-.96.32-.16.64-.48.96-.48.8-.16 1.6-.16 2.24.32.32.16.64.48.96.8l.47.96c.48 1.6-.47 3.04-2.07 3.51-.8.16-1.6 0-2.24-.31a4.24 4.24 0 0 1-.96-.8c-.16-.32-.48-.64-.48-.96-.16-.32-.16-.8 0-1.12 0-.32.16-.64.32-.96Z'
                fill='#CED6E2'
            />
            <g filter='url(#c)'>
                <path
                    d='m68.26 35.11 24.29 25.41c.8.96.8 2.24-.16 3.04L67.62 87.05c-.96.8-2.24.8-3.04-.16l-31-32.76c-.8-.96-.8-2.24.16-3.04l18.05-16.94 16.47.96Z'
                    fill='#F2F6FA'
                />
            </g>
            <path d='m51.64 33.83 6.71 7.04c.96.95 2.56.95 3.51 0l6.24-5.92-16.46-1.12Z' fill='#D5DAE6' />
            <path
                d='M53.55 55.73c0-.48.16-.96.32-1.44l.48-1.44c.16-.48.48-.96.8-1.44.32-.48.8-.95 1.28-1.43a6.09 6.09 0 0 1 2.08-1.44 4.92 4.92 0 0 1 2.07-.48c.64 0 1.44.16 2.08.32.64.32 1.28.8 1.92 1.28.48.48.96 1.11 1.12 1.75.16.48.32 1.12.48 1.76v1.6c-.16.48-.16.96-.32 1.44 0 .48-.16.8-.16 1.28 0 .32 0 .64.32.96l1.28 1.91-1.92 1.76-1.92-1.76c-.32-.32-.64-.64-.8-1.11-.16-.48-.16-.8-.16-1.28s.16-.96.16-1.44c.16-.48.16-.96.16-1.44s0-.96-.16-1.44a6.49 6.49 0 0 0-.8-1.44c-.16-.32-.48-.48-.8-.64-.32-.16-.64-.16-.95-.16-.32 0-.64.16-.96.32-.32.16-.64.32-.96.64-.32.32-.64.8-.96 1.12-.16.32-.32.64-.48 1.12-.16.32-.16.64-.16.8 0 .16-.16.32-.32.48-.16.32-.64.32-.96.16l-1.76-.32Zm14.71 11.19c-.16-.16-.32-.48-.48-.8-.16-.32-.16-.64-.16-.96 0-.64.32-1.28.8-1.76.16-.16.48-.32.79-.48.32-.16.64-.16.96-.16.96 0 1.92.64 2.24 1.6.16.32.16.64.16.96 0 .32-.16.64-.16.96a2.8 2.8 0 0 1-.64.8c-.16.16-.48.48-.8.48-.64.16-1.28.16-1.76 0-.47-.16-.79-.32-.95-.64Z'
                fill='#CED6E2'
            />
            <g filter='url(#d)'>
                <path
                    d='m131.7 75.07-9.43 33.72c-.32 1.12-1.59 1.91-2.71 1.43l-32.77-9.58c-1.11-.32-1.91-1.6-1.43-2.72l12.78-43.47c.32-1.12 1.6-1.92 2.72-1.44l23.81 7.03 7.03 15.03Z'
                    fill='#F2F6FA'
                />
            </g>
            <path d='m124.68 60.1-3.04 9.53c-.32 1.28.47 2.72 1.75 3.04l8.43 2.38-7.14-14.95Z' fill='#D5DAE6' />
            <path
                d='m106.61 72.99 1.44-.48c.48-.16.96-.32 1.6-.32h1.76c.64 0 1.27.16 1.91.32a7.58 7.58 0 0 1 3.84 2.72c.32.63.64 1.27.8 1.91.16.8 0 1.6-.16 2.24a5.4 5.4 0 0 1-.96 1.92 6.49 6.49 0 0 1-2.72 2.08l-1.44.48c-.31.16-.79.32-1.11.47-.32.16-.64.48-.64.8l-.96 2.08-2.56-1.12.48-2.55c0-.48.32-.8.64-1.12.32-.32.64-.64 1.12-.8.48-.16.96-.32 1.28-.48.48-.16.96-.32 1.44-.64.48-.16.79-.48 1.27-.8.32-.32.64-.8.8-1.44v-.8c0-.32-.16-.64-.32-.96-.16-.32-.48-.48-.8-.8a8.23 8.23 0 0 0-1.11-.47c-.48-.16-.96-.16-1.6-.16-.32 0-.8 0-1.12.16-.32 0-.64.16-.8.16-.16 0-.32.15-.64 0a.69.69 0 0 1-.64-.64l-.8-1.76Zm-2.39 18.38c.15-.32.15-.64.47-.8.16-.32.48-.48.64-.64a2.32 2.32 0 0 1 1.76-.16c.32.16.64.32.8.48l.64.64a2.15 2.15 0 0 1-.96 3.03c-.64.32-1.28.32-1.76.16-.32-.16-.64-.16-.8-.48-.32-.16-.48-.48-.64-.64-.15-.31-.15-.47-.31-.79.16-.16.16-.48.16-.8Z'
                fill='#CED6E2'
            />
            <g filter='url(#e)'>
                <path
                    d='m208.73 132.76-31 16.78c-.96.48-2.4.16-2.88-.96l-15.5-30.2c-.48-.96-.16-2.4.96-2.88l40.27-21.26c.96-.48 2.4-.16 2.88.96l11.19 21.9-5.92 15.66Z'
                    fill='#F2F6FA'
                />
            </g>
            <path d='m214.49 117.42-8.63 4.47a2.82 2.82 0 0 0-1.12 3.36l3.83 7.67 5.92-15.5Z' fill='#D5DAE6' />
            <path
                d='M193.07 113.26c.48.16.8.48 1.28.64.48.16.8.48 1.28.96s.8.8 1.12 1.28c.48.48.8.96 1.12 1.6.48.64.64 1.6.64 2.23.16.8 0 1.44 0 2.24-.16.64-.48 1.28-.8 1.92a5 5 0 0 1-1.76 1.44c-.48.32-1.28.48-1.92.64-.48.16-1.28.16-1.76 0s-1.12-.16-1.59-.48l-1.28-.64c-.32-.16-.8-.32-1.12-.48-.32-.16-.8-.16-.96.16l-2.08.8-1.12-2.4 2.08-1.44c.32-.32.8-.32 1.28-.32s.8 0 1.28.16.8.48 1.12.64c.48.16.8.48 1.43.64.48.16.8.16 1.44.32.48 0 .96-.16 1.6-.48.48-.32 1.12-.8 1.12-1.6.16-.32 0-.64 0-1.12-.16-.31-.16-.63-.48-1.11-.16-.48-.48-.8-.8-1.28-.16-.16-.48-.48-.8-.64-.16-.16-.48-.32-.64-.48-.16-.16-.32-.16-.48-.48-.16-.16-.16-.64 0-.8l.8-1.92Zm-14.86 11.03c.32-.16.48-.32.96-.16.32-.16.64 0 .8 0 .64.16 1.12.64 1.28 1.12.16.32.16.64.16.96v.8c-.16.48-.64 1.12-1.12 1.27-.32.17-.64.17-.96.17h-.8a1.85 1.85 0 0 1-1.28-1.12c-.16-.32-.16-.64-.16-.96-.16-.32 0-.64 0-.8.16-.32.32-.48.32-.8.16-.16.64-.16.8-.48Z'
                fill='#CED6E2'
            />
            <path
                d='M175.49 114.7v26.53a6.34 6.34 0 0 1-6.23 6.23H81.52a6.34 6.34 0 0 1-6.23-6.23v-28.77'
                stroke='#1676EE'
                strokeWidth='4.53'
                strokeLinejoin='round'
                strokeLinecap='round'
            />
            <path
                d='M172.14 97.6h-30.05c-2.87 0-5.75.96-7.99 2.88l-7.99 6.39a13.19 13.19 0 0 1-7.99 2.88h-34.2a6.23 6.23 0 0 0-6.23 6.23c0 .32 0 .64.16.96l6.23 32.76a6.47 6.47 0 0 0 6.23 5.43h73.04a6.21 6.21 0 0 0 6.23-5.27l8.79-45.07a6.16 6.16 0 0 0-5.27-7.03c-.32-.16-.64-.16-.96-.16Z'
                fill='#FFF'
            />
            <g filter='url(#f)'>
                <path
                    d='M180.45 91.69h-35.8c-3.36 0-6.87 1.28-9.43 3.35l-9.59 7.83a14.8 14.8 0 0 1-9.43 3.36H75.13c-4 0-7.51 3.2-7.51 7.51 0 .32 0 .8.16 1.12l7.51 39.79c.64 3.68 3.67 6.56 7.51 6.56h87.1a7.7 7.7 0 0 0 7.51-6.4l10.39-54.49c.64-4-2.08-7.99-6.24-8.63h-1.11Z'
                    fill='url(#g)'
                />
            </g>
            <path
                d='M111.41 133.56a3.9 3.9 0 0 0 3.83-3.84 3.89 3.89 0 0 0-3.83-3.83 3.9 3.9 0 0 0-3.84 3.83 3.9 3.9 0 0 0 3.84 3.84ZM141.29 132.92a3.9 3.9 0 0 0 3.84-3.84 3.9 3.9 0 0 0-3.84-3.83 3.88 3.88 0 0 0-3.83 3.83 3.88 3.88 0 0 0 3.83 3.84ZM134.42 139.31h-2.08a6.84 6.84 0 0 0-9.43-3.03 6.18 6.18 0 0 0-3.03 3.03h-2.08c1.76-4.63 7.03-7.03 11.51-5.27a9.23 9.23 0 0 1 5.11 5.27ZM194.99 174.15c-1.76 0-1.12.16-14.7-13.42-13.11 9.75-31.33.32-31.33-15.67 0-10.7 8.79-19.49 19.5-19.49 15.5 0 25.09 17.42 15.98 30.68l12.63 12.63a3 3 0 0 1-2.08 5.27Zm-26.37-42.35a13.4 13.4 0 0 0-13.42 13.42 13.3 13.3 0 0 0 13.42 13.43c.8 0 1.6 0 2.4-.16.8-.16 1.6-.32 2.24-.64.79-.32 1.43-.64 2.07-.96.8-.48 1.44-.96 2.08-1.6l1.6-1.6c.48-.63.96-1.27 1.28-1.91.32-.64.64-1.44.96-2.24.32-.8.48-1.6.48-2.4 0-.64.16-1.12.16-1.76a13.2 13.2 0 0 0-13.27-13.58Z'
                fill='#989FB0'
            />
            <path d='m101.98 123.17 8.63-4.63M140.17 116.14l8.64 4.79' stroke='#989FB0' strokeWidth='2.26' />
        </svg>
    );
};
